const checkboxStyles = theme => ({
  root: { color: '#2974FF !important' },
  checked: { color: '#2974FF !important' },
  default: { color: '#2974FF !important' },
});

export default checkboxStyles;



// WEBPACK FOOTER //
// ./src/components/checkbox/ListCheckboxStyles.js